import { render, staticRenderFns } from "./View6.vue?vue&type=template&id=05c35953"
import script from "./View6.vue?vue&type=script&lang=js"
export * from "./View6.vue?vue&type=script&lang=js"
import style0 from "./View6.vue?vue&type=style&index=0&id=05c35953&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports